import { render, staticRenderFns } from "./FileRecentView.vue?vue&type=template&id=3f311c04&scoped=true"
import script from "./FileRecentView.vue?vue&type=script&lang=js"
export * from "./FileRecentView.vue?vue&type=script&lang=js"
import style0 from "./FileRecentView.vue?vue&type=style&index=0&id=3f311c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f311c04",
  null
  
)

export default component.exports